// src/routes/componentMap.js
import Dashboard from "views/Dashboard/Dashboard.js";
import Asm from "views/Asm/Asm.js";
import Msdsales from 'views/Msdsales/Msdsales';
import softDrinks from 'views/SoftDrinks/softDrinks';
import Tables from "views/Dashboard/Abstract.js";
import DetailView from "views/Dashboard/Detailview.js";
import VisiCoolerImageReport from 'views/VisiCoolerImageReport/visiCoolerImageReport';
import RedAllocationSheet from 'views/RedAllocation/RedAllocationSheet';
import RedFreshness from 'views/RedFreshness/RedFreshness';
import SoviReport from 'views/SoviReport/SoviReport';
import ModalResults from 'views/ModalResults/ModalResults';
import RoleBasedAccess from 'views/RoleBasedAccess/RoleBasedAccess';
import SoftDrinkEdit from 'views/SoftDrinkEdit/SoftDrinkEdit';
import DownloadExcel from 'views/DownloadExcel/DownloadExcel.js';
import VarianceReport from 'views/VarianceReport/VarianceReport.js';
import StoreAbstract from 'views/StoreAbstract/StoreAbstract';


export const componentMap = {
  "/dashboard": Dashboard,
  "/Asm": Asm,
  "/MDC": Msdsales,
  "/Softdrink": softDrinks,
  "/StoreDetails": SoftDrinkEdit,
  "/ReportCenter": DownloadExcel,
  "/visicoolerImage": VisiCoolerImageReport,
  "/redAllocaion": RedAllocationSheet,     // note spelling from your routes.js
  "/redFreshness": RedFreshness,
  "/SoviReport": SoviReport,
  "/modelResults": ModalResults,
  "/role-based-access": RoleBasedAccess,
  "/variance-report": VarianceReport,
  "/storeAbstract": StoreAbstract,
  

  // From collapsed groups
  "/abstract": Tables,
  "/detail": DetailView,
  "/VisibilityItems": Tables, // adjust if needed

  // Fallback
  default: Dashboard,
};

export default componentMap;